import React from "react";
import {
	Container,
	Segment,
	Button,
	Image,
	Grid,
	Form,
	Icon,
	Tab,
} from "semantic-ui-react";

import Cropper from "./HiCropper";
import Painter from "./HiPainter";

class Display extends React.Component {
	state = {
		activeTab: 0,
		croppedImg: null,
	};
	render() {
		if (!this.props.photo) {
			return null;
		}

		console.log("Rendering Display");
		console.log("Active Tab: " + this.state.activeTab);

		const panes = [
			{
				menuItem: "Crop",
				render: () => (
					<Tab.Pane>
						<Cropper
							photo={this.props.photo}
							onCrop={(croppedImg) => {
								console.log("On Crop");
								this.setState({
									croppedImg: croppedImg,
									// activeTab: 1,
								});
							}}
						/>
					</Tab.Pane>
				),
			},
			// {
			// 	menuItem: "Resize",
			// 	render: () => <Tab.Pane>Coming soon...</Tab.Pane>,
			// },
			// {
			// 	menuItem: "Compress",
			// 	render: () => <Tab.Pane>Coming soon...</Tab.Pane>,
			// },
			{
				menuItem: "Paint",
				render: () => (
					<Tab.Pane>
						<Painter
							photo={this.props.photo}
							croppedImg={this.state.croppedImg}
						/>
					</Tab.Pane>
				),
			},
		];

		return (
			<Tab
				panes={panes}
				defaultActiveIndex={this.state.activeTab}
				// activeIndex={this.state.activeTab}
			/>
		);
	}
}

export default Display;
